export class ChannelSignalsMap {
  constructor(indicesList, clbKList, clbBList) {
    this.signalsMappedInfo = [];
    for (let i = 0; i < indicesList.length; i++) {
      this.signalsMappedInfo.push({
        index: indicesList[i],
        clbK: clbKList[indicesList[i]],
        clbB: clbBList[indicesList[i]]
      });
    }
  }

  // signals: array of { name:"signalName", data: [] }
  getPhysicValues(signals) {
    let mappedSignals = [];
    for (let signalIndex = 0; signalIndex < this.signalsMappedInfo.length; signalIndex++) {
      let currSignal = signals[this.signalsMappedInfo[signalIndex].index];
      let convertedSignal = {
        name: currSignal.name,
        data: []
      };
      convertedSignal.data.length = currSignal.data.length;
      let lsb = this.signalsMappedInfo[signalIndex].clbK * 0.001;
      let clbB = this.signalsMappedInfo[signalIndex].clbB;
      for (let pointIndex = 0; pointIndex < currSignal.data.length; pointIndex++) {
        convertedSignal.data[pointIndex] = currSignal.data[pointIndex] * lsb + clbB;
      }
      mappedSignals.push(convertedSignal);
    }
    return mappedSignals;
  }
}
